import { motion } from "framer-motion";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { CountryCard } from "../sections/CountriesSection";
import { COUNTRIES } from "../data/content";
import { stagger, usePageMeta } from "../lib/motion";

const CountriesPage = () => {
  usePageMeta("Countries", "Explore visa assistance destinations — Canada, UK, Australia, USA, New Zealand, Europe, Germany, France and UAE.");
  return (
    <main data-testid="countries-page">
      <PageHero
        eyebrow="DESTINATIONS"
        title="EXPLORE YOUR GLOBAL"
        highlight="DESTINATION"
        description="Nine destinations, countless opportunities. Choose where your journey leads."
      />
      <section className="py-20 lg:py-28 bg-navy-deep">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {COUNTRIES.map((c) => (
              <CountryCard key={c.slug} country={c} />
            ))}
          </motion.div>
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default CountriesPage;
